import { getWorkflowNodeIcon } from '@/utils/getWorkflowNodeIcon';

type ActionBreakdownItem = {
  name: string;
  type?: string;
};

type WorkflowBreakdownYAxisTickProps = {
  x?: number;
  y?: number;
  payload?: { value: string };
  data: ActionBreakdownItem[];
};

export default function WorkflowBreakdownYAxisTick({ x = 0, y = 0, payload, data }: WorkflowBreakdownYAxisTickProps) {
  const label = payload?.value ?? '';
  const item = data.find((entry) => entry.name === label);
  const icon = getWorkflowNodeIcon(item?.type, 24);

  return (
    <g transform={`translate(${x},${y})`}>
      <foreignObject x={-220} y={-12} width={220} height={24}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 8,
            width: '100%',
            height: '100%'
          }}
        >
          <span
            style={{
              fontSize: 14,
              color: '#374151',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {label}
          </span>
          {icon && <span style={{ display: 'flex', flexShrink: 0, alignItems: 'center' }}>{icon}</span>}
        </div>
      </foreignObject>
    </g>
  );
}
